import assert from "assert";
import GenUtils from "../../common/GenUtils";
/**
 * Models a Monero key image.
 */
export default class MoneroKeyImage {
    /**
     * Construct the model.
     *
     * @param {string|Partial<MoneroKeyImage>} [keyImageOrHex] is a MoneroKeyImage or hex string to initialize from (optional)
     * @param {string} [signature] is the key image's signature
     */
    constructor(hexOrKeyImage, signature) {
        if (typeof hexOrKeyImage === "string") {
            this.setHex(hexOrKeyImage);
            this.setSignature(signature);
        }
        else {
            Object.assign(this, hexOrKeyImage);
        }
    }
    getHex() {
        return this.hex;
    }
    setHex(hex) {
        this.hex = hex;
        return this;
    }
    getSignature() {
        return this.signature;
    }
    setSignature(signature) {
        this.signature = signature;
        return this;
    }
    copy() {
        return new MoneroKeyImage(this);
    }
    toJson() {
        return Object.assign({}, this);
    }
    merge(keyImage) {
        assert(keyImage instanceof MoneroKeyImage);
        if (keyImage === this)
            return this;
        this.setHex(GenUtils.reconcile(this.getHex(), keyImage.getHex()));
        this.setSignature(GenUtils.reconcile(this.getSignature(), keyImage.getSignature()));
        return this;
    }
    toString(indent = 0) {
        let str = "";
        str += GenUtils.kvLine("Hex", this.getHex(), indent);
        str += GenUtils.kvLine("Signature", this.getSignature(), indent);
        return str.slice(0, str.length - 1); // strip last newline
    }
}
